module.exports = __webpack_public_path__ + "media/site_templates/www.pianomovingservice.com.au/images/about_us-39ea12695e63f8e02ec093c5016871b4.jpg";